import { Children, cloneElement, isValidElement, useState } from 'react';

import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';

import {
  accordionClasses,
  accordionContentClasses,
  accordionIconClasses
} from './Accordion.styles';
import { accordionHeaderClasses } from './Accordion.styles';
import type {
  AccordionContentProps,
  AccordionHeaderProps,
  AccordionProps
} from './Accordion.types';

export const Accordion = ({
  children,
  isOpen = false,
  className,
  underline = true,
  ...props
}: AccordionProps) => {
  const [isOpenState, setIsOpen] = useState(isOpen);

  const childrenWithProps = Children.map(children, (child) =>
    isValidElement(child)
      ? cloneElement(child, { isOpen: isOpenState, setIsOpen } as AccordionHeaderProps)
      : child
  );

  return (
    <div className={cn(accordionClasses({ underline }), className)} {...props}>
      {childrenWithProps}
    </div>
  );
};

const Header = ({
  children,
  isOpen = false,
  setIsOpen,
  className,
  ...props
}: AccordionHeaderProps) => {
  const handleToggle = () => {
    setIsOpen?.(!isOpen);
  };

  return (
    <div className={cn(accordionHeaderClasses(), className)} onClick={handleToggle} {...props}>
      {children}
      <Icon name="ChevronDownSimple" className={cn(accordionIconClasses({ isOpen }))} />
    </div>
  );
};

const Content = ({ children, isOpen = false, className, ...props }: AccordionContentProps) => {
  return (
    <div className={cn(accordionContentClasses({ isOpen }), className)} {...props}>
      {children}
    </div>
  );
};

Accordion.Header = Header;
Accordion.Content = Content;
